import { LegalIdVerification } from "../components/legalIdVerification";

export function LegalIdVerificationPage() {
  return <LegalIdVerification />;
}
